import NiceModal from '@ebay/nice-modal-react'

import DeclinedSubmissionModal from 'container/AssignmentDetails/Modals/DeclinedSubmissionModal/DeclinedSubmissionModal'
import ReworkConfirmationModal from 'container/AssignmentDetails/Modals/ReworkConfirmationModal/ReworkConfirmationModal'
import StandardConfirmOrderModal from 'container/Projects/CreateProjectV2/modals/StandardConfirmOrderModal/StandardConfirmOrderModal'
import ConfirmProjectDuplicationModal from 'components/Modals/ConfirmProjectDuplicationModal/ConfirmProjectDuplicationModal'
import ProjectDuplicationServiceSelectionModal from 'components/Modals/ProjectDuplicationServiceSelectionModal/ProjectDuplicationServiceSelectionModal'
import CreateNewTemplateModal from 'components/Modals/TextTemplate/CreateNewTemplate'
import AddDomainModal from 'components/Modals/AddDomainModal/AddDomainModal'
import ReferenceCheckModal from 'components/Modals/ReferenceCheckModal/ReferenceCheckModal'
import TemplateViewerModal from 'components/Modals/TemplateViewer/TemplateViewerModal'
import ServiceSelectionDrawer from 'container/Projects/ServiceSelectionDrawer/ServiceSelectionDrawer'
import CreateContentModal from 'components/CreateContentModal'
import BuyCMP from 'components/Modals/BuyCMP'
import AllTemplatesModal from 'components/Modals/TemplatesModal/AllTemplatesModal'
import RemoveIntegrationModal from 'container/SEOTools/components/Modals/RemoveIntegrationModal'
import SelectProjectModal from 'components/SelectProjectModal'

export const registerModals = (): void => {
  NiceModal.register('decline-assignment-submission', DeclinedSubmissionModal)
  NiceModal.register('rework-confirmation', ReworkConfirmationModal)
  NiceModal.register('standard-confirm-order', StandardConfirmOrderModal)
  NiceModal.register(
    'confirm-project-duplication',
    ConfirmProjectDuplicationModal
  )
  NiceModal.register(
    'project-duplication-service-selection',
    ProjectDuplicationServiceSelectionModal
  )
  NiceModal.register('create-new-template', CreateNewTemplateModal)
  NiceModal.register('add-domain', AddDomainModal)
  NiceModal.register('reference-check', ReferenceCheckModal)
  NiceModal.register('template-viewer', TemplateViewerModal)
  NiceModal.register('service-selection-drawer', ServiceSelectionDrawer)
  NiceModal.register('create-seo-content', CreateContentModal)
  NiceModal.register('remove-integration', RemoveIntegrationModal)
  NiceModal.register('buy-cmp', BuyCMP)
  NiceModal.register('all-templates', AllTemplatesModal)
  NiceModal.register('select-project-modal', SelectProjectModal)
}
